export default "<p>common-dashboard works!</p>\n\n<app-common-blankspace></app-common-blankspace>\n"